const breakpoints = {
    extraSmall: 480,
    large: 1280,
    medium: 1024,
    small: 268,
};

export default breakpoints;
